// 用户取，流程导航
<template>
  <div class="flow userFetchFlow">
    <ul
      class="nav"
      :style="{backgroundPositionY: -(index-1) + 'rem'}">
      <li class="li" :class="{active : index == 1}">1. 请扫描您的员工卡/输入取件码<span></span></li>
      <li class="li" :class="{active : index == 2}">2. 打开箱子</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'userFetchFlow',
  props:['index'],
  data () {
    return {
    }
  },
  created () {
    console.log('index', this.index)
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style scoped>
.flow.userFetchFlow .nav{
  width: 11.02rem;
  background-image: url(/../static/turnoverCabinet/images/flow/userFetchFlow.png);
  background-repeat: no-repeat;
  background-position-x: 0;
  background-size: 11.02rem 2rem;
}

.flow.userFetchFlow .nav .li {
  width: 50%;
}
</style>




// WEBPACK FOOTER //
// src/components/turnoverCabinet/userFetch/userFetchFlow.vue